<template>
  <dropdown
    :name="dropdownName"
    :items="geographyNames"
    :on-clear="() => setGeoSelection(null)"
    :on-select="(item) => setGeoSelection(item)"
    :selected="geoSelection"
    :clearable="true" />
</template>

<script>
import { mapActions } from "vuex";

import Dropdown from "@/components/ui/Dropdown";

const props = {
  geoType: {
    type: String,
    required: false,
  },
  geoData: {
    type: Array,
    required: false,
  },
};

const components = {
  Dropdown,
};

const computed = {
  geographyNames() {
    if (!this.geoData) {
      return [];
    }
    let names = this.geoData.map((d) => d?.vcu ?? d?.name).filter((g) => g !== "" && g !== null);
    names = names.sort((a, b) => a.localeCompare(b));
    return names;
  },
  geoSelection() {
    return this.$store.getters.geoSelection;
  },
  dropdownName() {
    if (this.geoType === "Township") return this.$t("message.townshipResults");
    if (this.geoType === "County") return this.$t("message.countyResults");

    return `${this.geoType} Results`;
  },
};

const methods = {
  ...mapActions(["setGeoSelection"]),
  toplineResultsClick() {
    this.$nextTick(() => {
      this.$refs["geo-select"].blur();
      this.setGeoSelection(null);
    });
  },
};

export default {
  components,
  props,
  computed,
  mounted() {
    window.addEventListener("click", () => {
      if (this.$refs["geo-select"]) {
        this.$refs["geo-select"].blur();
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener("click", () => {
      if (this.$refs["geo-select"]) {
        this.$refs["geo-select"].blur();
      }
    });
  },
  methods,
};
</script>
